import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const SectionHeader = ({ section, onEdit, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({
    name: section.name,
  });

  // Reset edit data when section changes
  useEffect(() => {
    setEditData({
      name: section.name,
      name_arabic: section.name_arabic
    });
  }, [section]);

  const handleSave = () => {
    if (!editData.name.trim()) {
      alert('Section name is required');
      return;
    }
    
    if (!editData.name_arabic.trim()) {
      alert('Section name arabic is required');
      return;
    }

    onEdit({
      id: section.id,
      ...editData
    });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setIsEditing(false);
    // Reset to original values
    setEditData({
      name: section.name,
      name_arabic: section.name_arabic,
    });
  };

  return (
    <div className="sticky top-0 flex justify-between items-start bg-gold-light p-4 rounded-lg">
      {isEditing ? (
        <div className="flex-grow mr-4">
          <div className="flex flex-col gap-2 mb-2">
            <input
              type="text"
              className="w-full p-2 border border-gray-300 rounded"
              placeholder="Section Name"
              value={editData.name}
              onChange={(e) => setEditData({ ...editData, name: e.target.value })}
              required
            />
            <input
              type="text"
              className="w-full p-2 border border-gray-300 rounded"
              placeholder="Section Name (arabic)"
              value={editData.name_arabic}
              onChange={(e) => setEditData({ ...editData, name_arabic: e.target.value })}
              required
            />
          </div>
          <div className="flex gap-2 mt-2">
            <button
              className="px-3 py-1 bg-amber-700 text-white rounded hover:bg-amber-800"
              onClick={handleSave}
            >
              Save
            </button>
            <button
              className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-100"
              onClick={handleCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div className="flex-grow">
          <h2 className="text-xl font-bold text-amber-900 mb-1">{section.name} | {section.name_arabic}</h2>
        </div>
      )}
      
      {!isEditing && (
        <div className="flex gap-2">
          <button
            className="text-amber-700 hover:text-amber-900 px-3 py-1 rounded hover:bg-amber-100"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </button>
          {section.items.length === 0 &&
          <button
            className="text-red-600 hover:text-red-800 px-3 py-1 rounded hover:bg-red-100"
            onClick={() => onDelete(section.id)}
          >
            Delete
          </button>
          }
        </div>
      )}
    </div>
  );
};

SectionHeader.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default SectionHeader;